module.exports = __webpack_public_path__ + "static/external-34e4ebdb5c3ed8bc9cbb13b1becee92e.jpg";